import React, {
  Component,
  useState,
  useEffect,
  createRef,
  useRef,
} from "react";
import HanaHeader from "components/header/HanaHeader";
import Loader from "components/Loader";
import {
  ic_e_gold_img,
  ic_e_silver_img,
  ic_e_gold_text_b,
  ic_e_silver_text_b,
  input_x,
  del_btn,
  baseline_update_gray_48,
  ic_e_gold_img_big,
  ic_e_silver_img_big,
  bg_img_bottom,
  bg_img_top,
  bg_img_top_right,
  bg_img_top_left,
  icon_notice_n,
} from "styles/img";
import * as API from "lib/apis";
import { dateToString, numberWithCommas } from "lib/utils";
import { STORAGE_KEY } from "../../constants";
import { decodingBase64, encryptSHA256 } from "../../lib/utils";

const INIT_STATE = {
  isLoading: true,
  currentPrice: 0,
  diffPrice: 0,
  ocbPoint: 0,
  buyPoint: 0,
  keyPadModalVisible: false,
  prepareBuy: {},
  expired: true,
  buyResult: null,
};
class HanaBuy extends Component {
  constructor(props) {
    super(props);

    const urlParam = new URLSearchParams(this.props.location.search);
    const type = urlParam.get("type") || "peg";
    this.type = type;
    this.lock = createRef();
    this.state = { ...INIT_STATE };
  }
  componentDidMount() {
    this.lock.current = false;
    this.apiCall();
  }
  apiCall = () => {
    const type = this.type;

    const newState = {
      ...INIT_STATE,
      isLoading: false,
    };
    const apiPrice = API.getCurrentPrice(({ data }) => {
      newState["currentPrice"] = data[type + "Price"];

      let dataDiffKey = type === "peg" ? "diffPegPrice" : "diffPesPrice";
      newState["diffPrice"] = data[dataDiffKey];
    });

    const apiUserOcbPoint = API.getOcbPoint(({ data }) => {
      newState["ocbPoint"] = +data["ocbPoint"];
    });

    Promise.all([apiPrice, apiUserOcbPoint]).then(() =>
      this.setState(newState)
    );
  };

  handleClickInput = () => {
    const { buyPoint = 0, ocbPoint = 0 } = this.state;
    if (!buyPoint) {
      if (ocbPoint > 1000) {
        this.setState({ keyPadModalVisible: true });
      } else {
        alert(
          "하나머니를 최소 1,000머니 이상 보유해야 합니다.\n충전 후 매수 바랍니다."
        );
      }
    }
  };
  handleClickClear = (e) => {
    // x버튼 클릭 시 Init 상태로 초기화
    e && e.stopPropagation();
    this.lock.current = false;
    this.setState({ isLoading: true }, this.apiCall);
  };

  closeKeyPad = () => {
    this.setState({ keyPadModalVisible: false });
  };

  onClickInquiry = (buyPoint) => {
    this.closeKeyPad();

    this.setState({ isLoading: true }, () => {
      const type = this.type;
      API.getCurrentPrice(({ data }) => {
        let dataDiffKey = type === "peg" ? "diffPegPrice" : "diffPesPrice";
        this.setState({
          ...this.state,
          currentPrice: data[type + "Price"],
          diffPrice: data[dataDiffKey],
        });
      });
      API.getPrepareBuy(this.type, buyPoint, (res) => {
        const { businessTime, errorMessage, success, data } = res;
        if (!businessTime || !success) {
          alert(errorMessage);
          this.setState({ isLoading: false });
          return false;
        }

        this.setState({
          ...this.state,
          isLoading: false,
          buyPoint,
          prepareBuy: data,
          expired: false,
        });
      });
    });
  };

  disableBuy = () => {
    this.setState({ expired: true });
  };

  handleClickBuy = () => {
    if (this.lock.current) {
      alert(this.lock.current)
      return;
    }
    this.lock.current = true;
    const { buyPoint, expired } = this.state;

    if (buyPoint) {
      if (expired) {
        alert(
          "결제가능시간이 만료되었습니다.\n시세 확인 후 매수 금액을 다시 입력해주세요."
        );
        this.handleClickClear();
      } else {
        window.sendUsePoint = () => {
          this.passwordSuccessCallback();
        };
        window.location.href = "/CHECK_PASSWORD";
        this.lock.current = false;
      }
      this.lock.currnet = false;
    }
    this.lock.currnet = false;
  };

  passwordSuccessCallback = () => {
    const {
      prepareBuy: { id },
      expired,
    } = this.state;

    if (expired) {
      alert(
        "결제가능시간이 만료되었습니다.\n시세 확인 후 매수 금액을 다시 입력해주세요."
      );
      this.handleClickClear();
    } else {
      this.setState({ isLoading: true, expired: true }, () => {
        const encryptedParam = this.getEncryptParam(id);

        if (!encryptedParam) {
          alert("에러가 발생하였습니다.\n다시 시도해주세요.");
          this.handleClickClear();
          return;
        }
        API.reqBuyPoint(encryptedParam, (res) => {
          const { success, data, errorMessage } = res;
          if (success) {
            this.setState({ isLoading: false, buyResult: data }, () => {
              this.lock.currnet = false;
            });
          } else {
            alert(errorMessage);
            this.setState({ isLoading: false }, () => {
              this.lock.currnet = false;
            });
          }
        });
      });
    }
  };

  getEncryptParam = (id) => {
    const encSeq = localStorage.getItem(STORAGE_KEY.ACCESS_SEQUENCE);
    const decSeq = decodingBase64(encSeq);
    const param = id + "_" + new Date().getTime();
    return encryptSHA256(param, decSeq);
  };

  navigateMain = () => {
    this.setState({ isLoading: true }, () => {
      setTimeout(() => {
        this.props.history.push("/hana-main");
      }, 1000);
    });
  };

  render() {
    const type = this.type;
    const {
      isLoading,
      currentPrice = 0,
      ocbPoint,
      diffPrice,
      buyPoint,
      keyPadModalVisible,
      prepareBuy,
      expired,
      buyResult,
    } = this.state;

    const assetImage = type === "peg" ? ic_e_gold_img : ic_e_silver_img;
    const assetText = type === "peg" ? ic_e_gold_text_b : ic_e_silver_text_b;

    const diffPer = Math.floor((Math.abs(diffPrice) / (currentPrice - (diffPrice)) * 10000)) / 100;
    let opClass = "per";
    let opText = "";
    if (diffPrice > 0) {
      opClass = "per plus";
      opText = ` +${numberWithCommas(diffPrice)}▲ (+${diffPer}%) `;
    } else if (diffPrice < 0) {
      opClass = "per minus";
      opText = ` ${numberWithCommas(diffPrice)}▼ (${diffPrice}%) `;
    }

    // 매수 버튼 활성화 여부
    const canBuy = !!buyPoint;

    return (
      <>
        {isLoading && <Loader />}
        <div className="wrap hana_wrap" style={{ padding: 0 }}>
          <div className="section ">
            <div className="content product_hana">
              <HanaHeader point={ocbPoint} />
            </div>
          </div>

          <div className="sale_con">
            <div className="content">
              <div className="F_box">
                <div className="FL">
                  <div className="e_box1">
                    <div className="F_box">
                      <div className="FL">
                        <img src={assetImage} alt="e금 그림 아이콘" />
                      </div>
                      <div className="FR">
                        <img src={assetText} alt="e금 텍스트 아이콘" />
                        <p className="my_date">
                          {dateToString(new Date(), "MM/DD")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="FR">
                  <div className="my_money">
                    <p className="tt2">
                      {numberWithCommas(currentPrice)}
                      <span className="krw"> KRW</span>
                    </p>
                    <p className="tt3">
                      <span className={opClass}>{opText}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="content">
              <div className="tab_box">
                <div id="container">
                  <div id="tab1" className="tabcontent current">
                    <div
                      className={`input_box ${buyPoint ? "active" : ""}`}
                      onClick={
                        !buyPoint
                          ? this.handleClickInput
                          : this.handleClickClear
                      }
                    >
                      <div
                        className="input_text"
                        style={{
                          textAlign: !!buyPoint ? "right" : "",
                        }}
                      >
                        {!!buyPoint
                          ? numberWithCommas(buyPoint)
                          : "매수 금액을 입력해주세요"}
                      </div>
                      {!!buyPoint && (
                        <img
                          src={input_x}
                          alt="클릭 시 전체 삭제"
                          // onClick={this.handleClickClear}
                        />
                      )}
                    </div>

                    {/* <!-- 금액 입력 시 출력 --> */}
                    {!!buyPoint && (
                      <div className="info_p2" style={{ textAlign: "right" }}>
                        {numberWithCommas(buyPoint)} 머니
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="btn_area fixed MT30 apply_btn">
                <div className="bt_col1">
                  <input
                    type="button"
                    value="매수"
                    className={`${canBuy ? "" : "none"} navy pop`}
                    onClick={this.handleClickBuy}
                  />
                </div>
              </div>
            </div>
          </div>
          {!!buyPoint && (
            <PayTimer
              prepareBuy={prepareBuy}
              expiredCallback={this.disableBuy}
            />
          )}
          {keyPadModalVisible && (
            <KeypadModal
              point={ocbPoint}
              closeModal={this.closeKeyPad}
              onClickInquiry={this.onClickInquiry}
            />
          )}
          {buyResult && (
            <ResultModal
              type={this.type}
              buyResult={buyResult}
              onClickClear={this.navigateMain}
            />
          )}
        </div>
      </>
    );
  }
}
const PayTimer = ({ prepareBuy, expiredCallback }) => {
  const {
    estimateTrade: { amount, fee, price, totalPrice },
  } = prepareBuy;

  const [time, setTime] = useState(60);

  useEffect(() => {
    if (time > 0) {
      const Counter = setInterval(() => {
        setTime(time - 1);
      }, 1000);
      return () => clearInterval(Counter);
    } else {
      expiredCallback();
    }
  }, [time, expiredCallback]);

  let min = parseInt(time / 60);
  let sec = time % 60;

  if (min < 10) {
    min = "0" + min;
  }
  if (sec < 10) {
    sec = "0" + sec;
  }

  return (
    <div className="section bg_white">
      <p className="TXL timeB_wrap" style={{ marginBottom: 5 }}>
        <span className="timeB">
          <img src={baseline_update_gray_48} alt="더보기" />
          <span>
            결제가능시간{" "}
            <em>
              {min}:{sec}
            </em>
          </span>
        </span>
      </p>
      <div className="main_info_txt" style={{ marginTop: 0 }}>
        <img src={icon_notice_n} alt="icon" />
        입력한 금액 범위 내 최대 수량을 매수 합니다.
      </div>
      <div className="buy_wrap2">
        <ul className="pay_list">
          <li>
            <span className="left">단가</span>
            <span className="right">
              <em>{numberWithCommas(price)}</em>
              <span className="right3"> KRW</span>
            </span>
          </li>
          <li>
            <span className="left">수량</span>
            <span className="right">
              <em>{numberWithCommas(amount)}</em>
              <span className="right3"> g</span>
            </span>
          </li>
          <li>
            <span className="left">수수료(VAT포함)</span>
            <span className="right">
              <em>{numberWithCommas(fee)}</em>
              <span className="right3"> 머니</span>
            </span>
          </li>
          <li>
            <span className="left">매수 금액</span>
            <span className="right">
              <em>{numberWithCommas(totalPrice - fee)}</em>
              <span className="right3"> 머니</span>
            </span>
          </li>
        </ul>
      </div>
      <div className="charge_wrap2">
        <ul className="pay_list">
          <li>
            <span className="left">총 사용 금액</span>
            <span className="right">
              <em className="blue">{numberWithCommas(totalPrice)}</em>머니
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

const KeypadModal = ({ point, closeModal, onClickInquiry }) => {
  const [buyPoint, setBuyPoint] = useState(0);

  const handleClickKeypad = (num) => {
    return () => {
      let newBuyPoint = buyPoint * 10 + num;
      if (newBuyPoint > point) {
        newBuyPoint = point;
      }
      /* 
      if (newBuyPoint > 500000) {
        newBuyPoint = 500000;
      }
       */
      setBuyPoint(newBuyPoint);
    };
  };

  const handleClickDelete = () => {
    setBuyPoint(+("" + buyPoint).slice(0, -1));
  };

  const handleClickClear = () => {
    setBuyPoint(0);
  };

  const handleClickNext = () => {
    buyPoint >= 1000 && onClickInquiry(buyPoint);
    //&& buyPoint <= 500000
  };
  return (
    <div
      className="apply_form"
      onClick={closeModal}
      style={{ display: "block" }}
    >
      <div className="scroll_wrap">
        <div
          className="form_wrap"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="closed_slide"></div>
          <div className="input_wrap">
            <div className="info_p">
              나의 하나머니 <b>{numberWithCommas(point)}</b>
            </div>
            <div className={`input_box ${buyPoint ? "active" : ""}`}>
              <div
                className="input_text"
                style={{
                  textAlign: buyPoint ? "right" : "",
                }}
              >
                {buyPoint
                  ? numberWithCommas(buyPoint)
                  : "1,000머니부터 입력해주세요"}
              </div>

              {!!buyPoint && (
                <img
                  src={input_x}
                  alt="클릭 시 전체 삭제"
                  className=""
                  onClick={handleClickClear}
                />
              )}
            </div>

            {!!buyPoint && (
              <div className="info_p2" style={{ textAlign: "right" }}>
                {numberWithCommas(buyPoint)} 머니
              </div>
            )}
          </div>

          <div className="calc_box">
            <div className="button-wrap">
              <button onClick={handleClickKeypad(7)}>7</button>
              <button onClick={handleClickKeypad(8)}>8</button>
              <button onClick={handleClickKeypad(9)}>9</button>
              <button onClick={handleClickKeypad(4)}>4</button>
              <button onClick={handleClickKeypad(5)}>5</button>
              <button onClick={handleClickKeypad(6)}>6</button>
              <button onClick={handleClickKeypad(1)}>1</button>
              <button onClick={handleClickKeypad(2)}>2</button>
              <button onClick={handleClickKeypad(3)}>3</button>
              <button onClick={handleClickKeypad(point)}>전액</button>
              <button onClick={handleClickKeypad(0)}>0</button>
              <button className="dele" onClick={handleClickDelete}>
                <img src={del_btn} alt="e금 그림 아이콘" />
              </button>
            </div>
          </div>

          <div className="btn_area fixed MT30 apply_btn">
            <div className="bt_col1">
              <input
                type="button"
                value="조회"
                className={`${buyPoint >= 1000 ? "" : "none"} navy pop`}
                onClick={handleClickNext}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ResultModal = ({ type, buyResult, onClickClear }) => {
  const { amount, fee, price, totalPrice } = buyResult;

  const assetImage = type === "peg" ? ic_e_gold_img_big : ic_e_silver_img_big;
  const assetText = type === "peg" ? "e금" : "e은";
  return (
    <div className="apply_form center" style={{ display: "block" }}>
      <div className="scroll_wrap ">
        <div className="form_wrap sale_wrap">
          <div className="bg_img_top"></div>
          <h3 className="TXC">
            <img
              src={assetImage}
              alt="e금 그림 아이콘"
              className="pop_img_gold"
            />
            <br />
            {assetText} 매수확인
          </h3>
          <div className="buy_wrap2">
            <ul className="pay_list">
              <li>
                <span className="left">단가</span>
                <span className="right">
                  <em>{numberWithCommas(price)}</em>
                  <span className="right3"> KRW</span>
                </span>
              </li>
              <li>
                <span className="left">수량</span>
                <span className="right">
                  <em>{numberWithCommas(amount)}</em>
                  <span className="right3"> g</span>
                </span>
              </li>
              <li>
                <span className="left">수수료(VAT포함)</span>
                <span className="right">
                  <em>{numberWithCommas(fee)}</em>
                  <span className="right3"> 머니</span>
                </span>
              </li>
              <li>
                <span className="left">매수 금액</span>
                <span className="right">
                  <em>{numberWithCommas(totalPrice - fee)}</em>
                  <span className="right3"> 머니</span>
                </span>
              </li>
            </ul>
          </div>
          <div className="PB40">
            <span className="left2">총 사용 금액</span>
            <span className="right2">
              <em className="navy">{numberWithCommas(totalPrice)}</em>
              <span className="right4"> 머니</span>
            </span>
          </div>

          <div className="btn_area col_1">
            <span onClick={onClickClear} className="btn_mem navy">
              확인
            </span>
          </div>
          <div className="bg_img_bottom">
            <img src={bg_img_bottom} alt="팝업배경" className="pop_bg_img" />
          </div>
          <div className="bg_img_top">
            <img src={bg_img_top} alt="팝업배경" className="pop_bg_img" />
          </div>
          <div className="bg_img_top_right">
            <img src={bg_img_top_right} alt="팝업배경" className="pop_bg_img" />
          </div>
          <div className="bg_img_top_left">
            <img src={bg_img_top_left} alt="팝업배경" className="pop_bg_img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HanaBuy;
